import {
	SET_RENTALS,
	SET_RENTAL,
	CLEAR_RENTALS,
	CLEAR_RENTAL,
	ADD_RENTAL,
	UPDATE_RENTAL,
	REMOVE_RENTAL,
} from './actionTypes';

export const rental = (state = {}, action) => {
	switch (action.type) {
		case SET_RENTAL:
			return action.payload;
		case UPDATE_RENTAL:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_RENTAL:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_RENTALS:
			return action.payload;
		case ADD_RENTAL:
			return [...state, action.payload];
		case UPDATE_RENTAL:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_RENTAL:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_RENTALS:
			return [];
		default:
			return state;
	}
};
